import { createSlice } from "@reduxjs/toolkit";
import { userLogin } from "./action";

const readFromLocalStorage = (key) => {
    try {
        if (typeof window === "undefined") return null;
        return window.localStorage.getItem(key);
    } catch (error) {
        console.warn(`Unable to read ${key} from localStorage`, error);
        return null;
    }
};

const parseJSON = (value, fallback) => {
    if (!value) return fallback;
    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};

const storedIsAuthenticated = parseJSON(readFromLocalStorage("isAuthenticated"), false);
const storedBusiness = parseJSON(readFromLocalStorage("activeBusiness"), null);
const storedBusinesses = parseJSON(readFromLocalStorage("businesses"), []);

const initialState = {
    isAuthenticated: storedIsAuthenticated || false,
    loginStatus: "idle",
    loginError: null,
    userData: {},
    businesses: Array.isArray(storedBusinesses) ? storedBusinesses : [],
    selectedBusiness: storedBusiness,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state) => {
            state.isAuthenticated = false;
            state.businesses = [];
            state.selectedBusiness = null;
            localStorage.removeItem("isAuthenticated");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("activeBusiness");
            localStorage.removeItem("businesses");
        },
        setActiveBusiness: (state, action) => {
            state.selectedBusiness = action.payload || null;
            if (action.payload) {
                localStorage.setItem("activeBusiness", JSON.stringify(action.payload));
            } else {
                localStorage.removeItem("activeBusiness");
            }
        },
        setBusinesses: (state, action) => {
            const list = Array.isArray(action.payload) ? action.payload : [];
            state.businesses = list;
            try {
                localStorage.setItem("businesses", JSON.stringify(list));
            } catch {}
        },
        addBusiness: (state, action) => {
            const biz = action.payload;
            if (biz && biz._id) {
                const exists = state.businesses.some((b) => b._id === biz._id);
                const next = exists ? state.businesses : [...state.businesses, biz];
                state.businesses = next;
                try {
                    localStorage.setItem("businesses", JSON.stringify(next));
                } catch {}
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(userLogin.pending, (state) => {
                state.loginStatus = 'loading';
            })
            .addCase(userLogin.fulfilled, (state, action) => {
                state.loginStatus = 'succeeded';
                state.userData = action.payload;
                const list = action.payload?.businesses || [];
                state.businesses = list;
                localStorage.setItem("isAuthenticated", true);
                localStorage.setItem("userType", action.payload.user.userType);
                localStorage.setItem("accessToken", action.payload.accessToken);
                try {
                    localStorage.setItem("businesses", JSON.stringify(list));
                } catch {}
            })
            .addCase(userLogin.rejected, (state, action) => {
                state.loginStatus = 'failed';
                state.loginError = action.error.message;
            });
    }
});

export const { logout, setActiveBusiness, setBusinesses, addBusiness } = authSlice.actions;
export default authSlice.reducer;
